exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".input-group.aligned-prepend>.input-group-prepend{flex:0 0 45%}.input-group.aligned-prepend .input-group-text{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./components/tournament-creator.css
// module id = 467
// module chunks = 0